import { createBrowserRouter } from "react-router-dom";
import HomePage from "../pages/HomePage";
import NotFound from "../pages/NotFound";
import PerawatanAc from "../pages/PerawatanAc";
import KirPage from "../pages/KirPage";

const Router=createBrowserRouter([
    {
        path:"/:id",
        element:<HomePage/>
    },
    {
        path:"/perawatan-ac/:id",
        element:<PerawatanAc/>
    },
    {
        path:"/kir/:ruangan",
        element:<KirPage/>
    },
    {
        path:'*',
        element:<NotFound/>
    }
])

export default Router